import { useState } from 'react'
import { Link } from 'react-router-dom'
import { XIcon, CaretLeftIcon, UserCircleIcon } from '@phosphor-icons/react'
import { Icon } from '@/components/ui/Icon'
import { Sheet } from '@/components/ui/Sheet'
import { useAuth } from '@/app/auth/AuthContext'
import { CHEF_AVATAR_PLACEHOLDER } from '@/lib/assets'
import { OrdersRating } from './OrdersRating'
import styles from './OrdersProfileButton.module.css'

export function OrdersProfileButton() {
  const [open, setOpen] = useState(false)
  const { user } = useAuth()
  const name = user?.alias || 'آشپز مامان‌پز'
  const avatar = user?.profilePictureUrl || CHEF_AVATAR_PLACEHOLDER

  return <>
    <button type="button" className={styles.trigger} aria-label={`امتیاز ${name}`} aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(true)}>
      <span className={styles.name}>{name}</span>
      <img className={styles.avatar} src={avatar} alt="" onError={event => {
        if (event.currentTarget.getAttribute('src') !== CHEF_AVATAR_PLACEHOLDER) event.currentTarget.src = CHEF_AVATAR_PLACEHOLDER
      }} />
    </button>
    <Sheet open={open} onOpenChange={setOpen} title="امتیاز شما">
      <div className={styles.sheetHeader}>
        <div className={styles.sheetHeading}><span>{name}</span></div>
        <button type="button" className="app-header__icon-btn" aria-label="بستن" onClick={() => setOpen(false)}><Icon as={XIcon} /></button>
      </div>
      <OrdersRating />
      <Link to="/profile" className={styles.profileLink} onClick={() => setOpen(false)}><span className={styles.profileLabel}><Icon as={UserCircleIcon} /><span>مشاهده پروفایل</span></span><Icon as={CaretLeftIcon} size="sm" /></Link>
    </Sheet>
  </>
}
